import styled from "styled-components";

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
`;

export const Title = styled.div`
  font-weight: bold;
  font-size: 16px;
  color: #2c3e50;
`;

export const GreenButton = styled.button`
  background: ${(p) => (p.disabled ? "#cccccc" : "#16a34a")};
  color: ${(p) => (p.disabled ? "#888888" : "white")};
  border: ${(p) => (p.disabled ? "1px solid #aaaaaa" : "none")};
  padding: 10px 14px;
  border-radius: 6px;
  cursor: ${(p) => (p.disabled ? "not-allowed" : "pointer")};
  font-weight: 700;
  white-space: nowrap;
  opacity: ${(p) => (p.disabled ? 0.6 : 1)};
  pointer-events: ${(p) => (p.disabled ? "none" : "auto")};
`;

/* =========================================================
   ✅ ESTRUCTURA TIPO MOCKUP (TABLA REAL)
   - Scroll horizontal consistente en 100% / 125%
   - Acciones NO se pierden
   - Estilo similar al HTML de referencia
========================================================= */

export const TableOuter = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: white;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden; /* el scroll lo maneja ScrollX */
`;

export const ScrollX = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;

  /* deja un pequeño respiro para la barra horizontal */
  padding-bottom: 6px;
`;

/* tabla principal */
export const CoveragesTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  /* importante: asegura que haya scroll si no cabe */
  min-width: 1250px;

  th,
  td {
    text-align: left;
    padding: 8px;
    border-bottom: 1px solid #e5e7eb;
    font-size: 0.8rem;
    vertical-align: top;
    box-sizing: border-box;
    overflow: hidden; /* evita que rompa layout */
  }

  thead th {
    background-color: #38bdf8;
    color: #fff;
    font-weight: 600;
    white-space: nowrap;
  }

  tbody td {
    background: #fff;
  }
`;

/* Inputs dentro de la tabla (similar mockup) */
export const Input = styled.input`
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  background-color: ${(p) => (p.disabled ? "#e5e7eb" : "#f9fafb")};
  padding: 0.3rem 0.6rem;
  font-size: 0.8rem;
  line-height: 1.25rem;
  box-sizing: border-box;
  min-width: 0;
  color: ${(p) => (p.disabled ? "#6b7280" : "inherit")};
  cursor: ${(p) => (p.disabled ? "not-allowed" : "text")};

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 1px #3b82f6;
  }

  &:disabled {
    background-color: #e5e7eb;
    color: #6b7280;
    cursor: not-allowed;
  }
`;

export const Select = styled.select`
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  background-color: #f9fafb;
  padding: 0.3rem 0.6rem;
  font-size: 0.8rem;
  line-height: 1.25rem;
  box-sizing: border-box;
  min-width: 0;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 1px #3b82f6;
  }
`;

export const ReadonlyInput = styled(Input)`
  background-color: #e5e7eb;
  cursor: not-allowed;
  color: #6b7280;
`;

/* botón ícono (lupa) como en mockup */
export const IconBtn = styled.button`
  background: none;
  border: none;
  cursor: ${(p) => (p.disabled ? "not-allowed" : "pointer")};
  color: ${(p) => (p.disabled ? "#cccccc" : p.$color || "#0077c8")};
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  opacity: ${(p) => (p.disabled ? 0.5 : 1)};

  &:hover {
    color: ${(p) => (p.disabled ? "#cccccc" : p.$hover || "#005a9a")};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

/* celda acciones: no se encoge y siempre visible al scrollear */
export const ActionsCell = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
`;

/* =========================================================
   FOOTER dentro del mismo bloque (como mockup)
========================================================= */

export const FooterRow = styled.div`
  padding: 16px 14px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  background: white;
`;

export const VoucherGroup = styled.div`
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
`;

export const VoucherButton = styled.button`
  border: 1px solid
    ${(p) => (p.disabled ? "#cccccc" : p.$primary || "#00a0df")};
  color: ${(p) => (p.disabled ? "#999999" : p.$primary || "#00a0df")};
  background: ${(p) => (p.disabled ? "#f5f5f5" : "transparent")};
  padding: 6px 10px;
  border-radius: 6px;
  font-weight: 700;
  cursor: ${(p) => (p.disabled ? "not-allowed" : "pointer")};
  opacity: ${(p) => (p.disabled ? 0.6 : 1)};
  pointer-events: ${(p) => (p.disabled ? "none" : "auto")};
`;

export const TotalsBox = styled.div`
  display: flex;
  gap: 26px;
  align-items: center;
  font-size: 13px;
  color: #334155;
  font-weight: 600;
  flex-wrap: wrap;
`;

export const TotalValue = styled.span`
  margin-left: 10px;
  font-weight: 800;
  color: #0f172a;
`;

/* =========================================================
   MODAL
========================================================= */

export const ModalBody = styled.div`
  padding: 10px;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const ModalTitle = styled.h3`
  margin: 0;
  font-weight: bold;
`;

export const ModalSearch = styled(Input)`
  width: 320px;
  max-width: 100%;
`;

export const SelectBtn = styled.button`
  background: ${(p) => (p.disabled ? "#cccccc" : "#0b66c3")};
  color: ${(p) => (p.disabled ? "#888888" : "white")};
  border: none;
  padding: 6px 10px;
  border-radius: 6px;
  font-weight: 700;
  cursor: ${(p) => (p.disabled ? "not-allowed" : "pointer")};
  opacity: ${(p) => (p.disabled ? 0.6 : 1)};
  pointer-events: ${(p) => (p.disabled ? "none" : "auto")};
`;

/* =========================================================
   BARRA DE ACCIONES FINAL (Enviar / Cancelar)
========================================================= */

export const ActionsBar = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 14px;
  margin-top: 14px;
`;

export const PrimaryAction = styled.button`
  background: ${({ disabled }) => (disabled ? "#cccccc" : "#00a0df")};
  color: ${({ disabled }) => (disabled ? "#888888" : "#fff")};
  border: ${({ disabled }) => (disabled ? "1px solid #aaaaaa" : "none")};
  padding: 10px 22px;
  border-radius: 8px;
  font-weight: 700;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  white-space: nowrap;
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  transition: background 0.2s, opacity 0.2s;
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};

  &:hover {
    background: ${({ disabled }) => (disabled ? "#cccccc" : "#0088c0")};
  }
`;

export const SecondaryAction = styled.button`
  background: ${({ disabled }) => (disabled ? "#f5f5f5" : "#fff")};
  color: ${({ disabled }) => (disabled ? "#999999" : "#00a0df")};
  border: ${({ disabled }) => (disabled ? "1px solid #cccccc" : "1px solid #00a0df")};
  padding: 10px 22px;
  border-radius: 8px;
  font-weight: 700;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  white-space: nowrap;
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
`;
